import { media } from '@mf/common/utils/styles';
import { FsModal } from '@printi/ds-offset-react-core';
import styled from 'styled-components';

export const ModalContainer = styled(FsModal)`
  z-index: 1002;
  padding: 0;

  #modal {
    height: 95vh;
    width: 50vw;

    > div:nth-of-type(3) {
      display: none;
    }
  }

  @media only screen and (max-width: 1023px) {
    #modal {
      width: 90vw;
      bottom: unset;
    }
  }
`;

export const ModalContent = styled.div`
  overflow-y: auto;

  > div {
    padding: 0 var(--spacing-5x);
  }

  > div:nth-of-type(1) > div {
    gap: 0;

    > div:nth-of-type(1) {
      display: block;
    }

    > div:nth-of-type(1) > div {
      padding: 0 0 var(--spacing-2x) 0;
    }
  }

  div {
    max-width: 100%;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: var(--neutral-color-lighter);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--neutral-color-light);
    border-radius: 3px;
  }
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--spacing-15x) var(--spacing-5x);
  max-width: 1440px;
  margin: 0 auto;
  box-sizing: border-box;

  &:last-of-type {
    margin-bottom: var(--spacing-4x);
  }

  ${media.lessThan('mobile')} {
    padding: var(--spacing-2x) var(--spacing-2x) var(--spacing-7x)
      var(--spacing-2x);
    align-items: flex-start;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export const SectionsContainer = styled.div`
  display: grid;
  gap: var(--spacing-10x);
  width: 100%;

  ${media.lessThan('mobile')} {
    gap: var(--spacing-6x);
  }
`;
